var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthenticationCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 104,
    viewBox: "0 0 120 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_8407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2285 57.8772L100.264 34.761V79.5879C100.264 80.4549 99.7989 81.2671 99.0414 81.696L64.2257 101.801L61.4423 103.407C60.6848 103.845 59.754 103.845 59.0056 103.407L56.2222 101.801L21.4065 81.696C20.649 81.258 20.1836 80.4549 20.1836 79.5879V34.761L60.2194 57.8772H60.2285Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1924 34.761L60.2282 11.6448L100.264 34.761L60.2282 57.8771L20.1924 34.761Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1924 34.761L60.2282 57.8771L100.264 34.761L60.2282 11.6448L20.1924 34.761Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4787 93.9888L54.4879 87.1443L42.4872 80.0717L42.478 86.9162L54.4787 93.9888Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2284 57.8772L40.8174 69.0839C40.4432 69.3029 39.9778 69.3029 39.5945 69.0839L1.27438 46.9533C0.790701 46.6704 0.790701 45.9677 1.27438 45.6848L20.1926 34.761L60.2284 57.8772Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2285 11.6448L79.6395 0.438072C80.0137 0.219048 80.4791 0.219048 80.8624 0.438072L119.192 22.5686C119.675 22.8516 119.675 23.5543 119.192 23.8372L100.273 34.761L60.2285 11.6448Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2285 57.8772L79.6395 69.0839C80.0137 69.3029 80.4791 69.3029 80.8624 69.0839L119.192 46.9533C119.675 46.6704 119.675 45.9677 119.192 45.6848L100.273 34.761L60.2376 57.8772H60.2285Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2284 11.6448L40.8265 0.438072C40.4523 0.219048 39.9869 0.219048 39.6036 0.438072L1.27438 22.5686C0.790701 22.8516 0.790701 23.5543 1.27438 23.8372L20.1926 34.761L60.2284 11.6448Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2285 57.8772V103.726",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2558 45.4475C72.7302 45.4475 82.8427 35.3351 82.8427 22.8607C82.8427 10.3863 72.7302 0.273804 60.2558 0.273804C47.7814 0.273804 37.6689 10.3863 37.6689 22.8607C37.6689 35.3351 47.7814 45.4475 60.2558 45.4475Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9566 16.1896L56.6144 29.5318L50.5547 23.463",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_8407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.642,
    height: 104,
    fill: "white",
    transform: "translate(0.179199)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationCompleted);
export default __webpack_public_path__ + "static/media/authentication_completed.89d0930cb8e4c7cf27ed934d007c5219.svg";
export { ForwardRef as ReactComponent };